/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Button, Flex, Heading, Icon, Link, Text } from '@chakra-ui/react';
import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import { usePageType } from '@hooks/usePageType';
import { ProgramFeeSt } from '@ieo/Common/CompLangConfig';
import { gtmObject } from '@ieo/Components/Form/ieo/api/analyticsAPi';
import { useProgramLanguageSelection } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
import { programTypes } from '@ieo/Components/Form/ieo/utils';
import DayTimeCounterText from '@ieo/Components/Timer/DayTimeCounterText';
/* Service */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';

/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const ProgramFeesEuDiscount = ({
  sectionContent,
  region,
  lang,
  prgData,
  pageData,
}) => {
  // const toast = useToast();
  const [isOpen1, setIsOpen1] = useState(false);

  const priceData = Object.values(prgData);
  // console.log(priceData, 'pricedata');
  const [isGiftingFlow, setIsGiftingFlow] = useState();
  const { setProgramLanguage } = useProgramLanguageSelection();
  const [showTimer, setShowTimer] = useState(false);

  // currentDate,
  // endDate

  const transProviderObj =
    (pageData._allSharedJsonLocales?.length &&
      pageData._allSharedJsonLocales[0]?.value.json) ||
    pageData.sharedJson?.json;
  const { isGiftPage } = usePageType();

  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const additionalText = sectionContent?.find(
    e => e.fieldId === 'additional-off'
  );

  const router = useRouter();

  const changeUi =
    router.asPath.indexOf('inner-engineering-pc') > 0 && isIndian;

  //console.log('====sectionContent===', sectionContent);

  const currentDate = new Date();
  const getLocalTime =
    currentDate.getFullYear() +
    '-' +
    String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(currentDate.getDate()).padStart(2, '0') +
    'T' +
    String(currentDate.getHours()).padStart(2, '0') +
    ':' +
    String(currentDate.getMinutes()).padStart(2, '0') +
    ':' +
    String(currentDate.getSeconds()).padStart(2, '0');

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  const gtmClick = (lang, price) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'IE_Language_Selected',
        IE_Lang: lang,
        IE_LP_Location: 'Language_Table',
      });

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_wishlist',
        ecommerce: {
          currency: 'INR', // currency code (Ex - INR,USD,AUD etc.)
          value: price || priceData[0].discountedPrice || '',
          items: [
            {
              item_id: programTypes.IEO, // id of the program
              item_name: isGiftPage
                ? 'Gift Inner Engineering'
                : 'TYLS Inner Engineering', // Name of the program (Ex - TYLS Inner Engineering)
              affiliation: '',
              coupon: '',
              discount: 0, //Actual Discount if any (actual price - pay price)
              index: '',
              item_brand: '', // Country Code (Ex - US,IN etc.)
              item_category: '', // Language (Ex - English,Spanish etc.)
              item_category2: '', // Bay Name (not reuired for IE)
              item_category3: '', // New_User or Repeat_User
              item_category4: 'Language_Table',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: '',
              price: price || priceData[0].discountedPrice || '',
              quantity: '',
            },
          ],
        },
      });

      gtmObject({
        event: isGiftPage ? 'IE_Gift_Inner_Engineering' : 'IE_Register_Now',
        IE_LP_Location: 'Sticky_CTA',
        event1: 'view_item',
        item_name: isGiftPage
          ? 'Gift Inner Engineering'
          : 'TYLS Inner Engineering',
        item_category4: 'Language_Table',
      });
    }
  };

  useEffect(() => {
    if (
      // (
      // changeUi ||
      // router.asPath.split('?')[0].endsWith('inner-engineering') ||
      // router.asPath.split('#')[0].endsWith('inner-engineering')) &&
      isThemeActive &&
      pageConfigVal?.topbanner?.topAd?.countDown &&
      !showTimer
    ) {
      setShowTimer(true);
    }
  }, [isThemeActive]);

  let PriceDataList = [];

  if (region === 'in') {
    config.orderedLangList[lang].forEach(language => {
      const price = priceData.filter(item => {
        return item.lang === language.toUpperCase();
      });
      if (price.length > 0) {
        PriceDataList.push(price[0]);
      }
    });
  } else {
    PriceDataList = [...priceData];
  }

  const [discountText, setDiscountText] = useState({});

  useEffect(() => {
    if (priceData?.length) {
      let filteredText = filter(pageConfigVal?.discounText, function (item) {
        return (
          item.code === priceData[0].coupon?.couponCode &&
          item.lang?.toLowerCase() === lang.toLowerCase()
        );
      });
      if (filteredText?.length) {
        setDiscountText(filteredText[0]);
      }
    }
  }, [priceData]);

  useEffect(() => {
    if (router.asPath.indexOf('/gift') > -1) {
      setIsGiftingFlow(true);
    }
  }, [router.asPath]);

  const clickCopyCode = code => {
    copy(code);
    setCouponCopied(true);
    setTimeout(function () {
      setCouponCopied(false);
    }, 1000);
  };

  //console.log('priceData[0]===', priceData[0]);

  return (
    <Box
      bg={
        pageConfigVal?.prgFees?.bgImage?.desktop &&
        priceData[0]?.coupon?.postCouponPrice
          ? `url(${pageConfigVal?.prgFees?.bgImage?.desktop})`
          : `url(https://static.sadhguru.org/d/46272/1694863180-program-fee.png)`
      }
      bgRepeat="no-repeat"
      bgSize="cover"
      bgColor="#00005B"
    >
      <Flex
        maxW={1030}
        bgRepeat="no-repeat"
        pt={{ base: '60px', md: '100px' }}
        id="ieo-program-fees"
        mx="auto"
        // mt={{ base: '0px', md: '-140px' }}
      >
        <Flex
          w="full"
          mx="auto"
          flexWrap="wrap"
          px={{ base: '16px', xl: 0 }}
          pt={{
            base: '0px',
            md: lang === 'ar' ? '30px' : '40px',
            xl: '40px',
          }}
        >
          <Flex
            w="full"
            px={{ base: '16px', xl: 0 }}
            flexDir={{ base: 'column', lg: 'row' }}
            justifyContent="space-between"
            alignItems={'flex-start'}
            gridGap={{ base: '30px', md: '80px', '2xl': '70px' }}
            css={{
              '-webkit-grid-gap': '40px',
              '@media screen and (min-width: 768px)': {
                '-webkit-grid-gap': '80px',
              },
            }}
            pb="40px"
          >
            <Box
              color="#fff"
              w={{
                base: '100%',
                md: '60%',
                lg: '80%',
                xl: pageConfigVal?.prgFees?.offerBg?.desktop ? '65%' : '60%',
                '2xl': pageConfigVal?.prgFees?.offerBg?.desktop ? '65%' : '60%',
              }}
              display="flex"
              justifyContent="flex-start"
              flexDirection="column"
              alignItems={lang === 'ar' ? 'flex-end' : 'flex-start'}
            >
              <Heading
                as="h2"
                {...ProgramFeeSt[lang].h2}
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
              >
                {sectionContent?.[0]?.titleText}
              </Heading>
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[1].body)}
                {...ProgramFeeSt[lang].p}
                maxW="auto"
                color="#fff"
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
              />
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[2].body)}
                {...ProgramFeeSt[lang].p1}
                maxW="auto"
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
                mb="20px"
              />

              {region !== 'in' &&
                transProviderObj?.globalLanguages &&
                !isGiftingFlow && (
                  <Box position="relative" mt="20px">
                    <Button
                      flex="1"
                      bg="#B49168"
                      border="none"
                      color="#fff"
                      w="50%"
                      maxW={{ base: 'auto', xl: '297px' }}
                      minW={{ base: '254px', md: '260px' }}
                      h={{ base: '36px', md: '46px' }}
                      rounded="full"
                      position="relative"
                      zIndex={88}
                      justifyContent="space-between"
                      _hover={{ border: 'none' }}
                      _focus={{ border: 'none' }}
                      _active={{ border: 'none' }}
                      // rightIcon={isOpen ? <TbChevronUp /> : <TbChevronDown />}
                      onClick={() => setIsOpen1(!isOpen1)}
                      textTransform="capitalize"
                      {...ProgramFeeSt[lang].selectLang}
                    >
                      {' '}
                      <Text
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        display="flex"
                        gridGap="10px"
                        alignItems="center"
                      >
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 36 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.12842 11.6252H25.8784V27.3752H15.7534L9.00342 31.1252V27.3752H4.12842V11.6252Z"
                            fill="white"
                          />
                          <path
                            d="M25.8751 21.3752H31.8784V5.62524H10.5034V11.6252M25.8784 11.6252H4.12842V27.3752H9.00342V31.1252L15.7534 27.3752H25.8784V11.6252Z"
                            stroke="white"
                            strokeWidth="2.25"
                            strokeLinecap="square"
                          />
                        </svg>
                        {transProviderObj?.formFields?.selectLanguage}
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 36 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30 13.5002L18 25.5002L6 13.5002"
                            stroke="white"
                            strokeWidth="2.25"
                            strokeLinecap="square"
                          />
                        </svg>
                      </Text>
                    </Button>

                    <Flex
                      _before={{ content: "''", height: '17px' }}
                      _after={{ content: "''", height: '17px' }}
                      display={isOpen1 ? 'block' : 'none'}
                      _hover={{ display: 'block' }}
                      className="options"
                      zIndex="9"
                      alignItems="flex-start"
                      alignContent="flex-start"
                      onClick={() => setIsOpen1(!isOpen1)}
                      position="absolute"
                      top={{ base: '25px', md: '18px' }}
                      border="1px solid #EDD1C2"
                      left="0"
                      borderRadius="0 0 14px 14px"
                      minW={{ base: '250px', md: '260px' }}
                      flexDir="column"
                      bg="#ffffff"
                      mt={{ base: '0', md: '8px' }}
                      w="auto"
                      p="17px 17px 0 17px"
                    >
                      <Box padding="8px 0" cursor="pointer">
                        {Object.keys(transProviderObj?.globalLanguages)?.map(
                          (language, index) => {
                            return (
                              <Box
                                padding="8px 0"
                                key={nanoid()}
                                cursor="pointer"
                                onClick={() => {
                                  setProgramLanguage(language.toUpperCase());
                                  gtmClick(language.toUpperCase());
                                }}
                              >
                                <Text
                                  {...ProgramFeeSt[lang].selectLangDrowDown}
                                  color="#6D6358"
                                  textAlign="left"
                                  _hover={{ color: '#CE6113' }}
                                  dir={lang == 'ar' ? 'rtl' : 'ltr'}
                                >
                                  {transProviderObj?.globalLanguages[language]}
                                </Text>
                              </Box>
                            );
                          }
                        )}
                      </Box>
                    </Flex>
                  </Box>
                )}
            </Box>

            {priceData[0]?.coupon?.couponCode &&
            isThemeActive &&
            pageConfigVal?.prgFees ? (
              <Flex
                bg={{
                  base: `url(${sectionContent[12]?.mobileImage?.url})`,
                  md: `url(${sectionContent[12]?.image?.url})`,
                }}
                bgSize={{ base: 'contain', md: 'cover' }}
                py={{ base: '20px', md: '86px' }}
                px={{ base: '20px', md: '80px' }}
                flexDir="column"
                maxW="520px"
              >
                <Flex
                  alignItems={'flex-start'}
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  <Flex>
                    <Icon width="27" height="27">
                      <svg
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_16065_2835)">
                          <path
                            d="M22.4755 26.7385H3.95681C3.62683 26.7385 3.35938 26.4711 3.35938 26.1411V15.7879C3.35938 15.4579 3.62683 15.1904 3.95681 15.1904H22.4757C22.8056 15.1904 23.0733 15.4581 23.0733 15.7879V26.1411C23.0733 26.4711 22.8056 26.7385 22.4757 26.7385H22.4755ZM4.55424 25.5435H21.8779V16.3853H4.55424V25.5435Z"
                            fill="#BD0015"
                          />
                          <path
                            d="M25.8241 16.385H0.597433C0.267452 16.385 0 16.1173 0 15.7875V11.2671C0 10.9371 0.267628 10.6697 0.597433 10.6697H25.8241C26.1541 10.6697 26.4217 10.9371 26.4217 11.2671V15.7875C26.4217 16.1175 26.1541 16.385 25.8241 16.385ZM1.19504 15.1899H25.2265V11.8645H1.19504V15.1899Z"
                            fill="#BD0015"
                          />
                          <path
                            d="M15.3225 11.2666H11.0938V26.1401H15.3225V11.2666Z"
                            fill="#BD0015"
                          />
                          <path
                            d="M13.2077 10.2611C13.1393 10.2611 13.071 10.2494 13.005 10.2257C8.51594 8.6068 6.17 6.34581 5.83319 3.31346C5.67905 1.9254 6.39594 0.710042 7.65999 0.217523C8.82946 -0.238214 10.4939 -0.0387198 11.5753 1.43621C13.2583 3.73118 13.7814 9.37133 13.8026 9.61023C13.821 9.81358 13.7343 10.0122 13.5727 10.1367C13.4665 10.2184 13.3378 10.2611 13.2077 10.2611ZM8.82578 1.19608C8.56533 1.19608 8.3154 1.2446 8.09401 1.33077C7.32668 1.62975 6.92541 2.32176 7.02105 3.18139C7.28044 5.51718 9.07589 7.34503 12.5011 8.75148C12.2818 7.07233 11.7168 3.64992 10.6114 2.14258C10.1151 1.46581 9.44108 1.19608 8.82578 1.19608Z"
                            fill="#BD0015"
                          />
                          <path
                            d="M10.8827 10.8728C7.44311 10.8728 3.78618 8.09806 3.59264 7.949C3.33114 7.74793 3.2821 7.37311 3.48317 7.11162C3.68442 6.84994 4.05889 6.80038 4.32091 7.0018C4.37468 7.04261 9.7253 11.1003 12.9043 9.15315C13.1852 8.98116 13.5535 9.06891 13.7255 9.3509C13.8981 9.63218 13.8096 10 13.528 10.1723C12.709 10.6738 11.8036 10.8728 10.8827 10.8728Z"
                            fill="#BD0015"
                          />
                          <path
                            d="M13.2073 9.47295C12.8819 9.47295 12.6162 9.21268 12.6099 8.88708C12.6067 8.72121 12.5586 4.80821 14.9903 3.18703C16.4661 2.2034 17.9906 2.69784 18.848 3.62315C19.6992 4.54286 19.8216 5.78694 19.1461 6.64868C17.8906 8.24919 15.3391 9.46314 13.2103 9.47313H13.2075L13.2073 9.47295ZM16.6788 3.84787C16.3577 3.84787 16.0094 3.94385 15.6529 4.18153C14.2614 5.10929 13.9165 7.18533 13.8321 8.23342C15.4519 8.01869 17.307 7.0566 18.2057 5.91095C18.5639 5.45381 18.3462 4.84026 17.9708 4.43497C17.6741 4.11427 17.214 3.84769 16.6789 3.84769L16.6788 3.84787Z"
                            fill="#BD0015"
                          />
                          <path
                            d="M16.4603 10.586C15.2912 10.586 14.0666 10.2383 12.8558 9.35923C12.5889 9.16551 12.5295 8.79174 12.7235 8.52464C12.9171 8.25771 13.2909 8.19834 13.5581 8.3924C15.318 9.67011 17.2574 9.73369 19.3225 8.58016C20.9263 7.68428 21.9917 6.38327 22.0024 6.37031C22.2107 6.11442 22.5871 6.07501 22.8429 6.28273C23.099 6.49064 23.1382 6.86703 22.9303 7.1231C21.7404 8.58962 19.261 10.586 16.4603 10.586Z"
                            fill="#BD0015"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_16065_2835">
                            <rect
                              width="26.4217"
                              height="26.7377"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </Icon>
                  </Flex>
                  <Box
                    as="span"
                    {...ProgramFeeSt[lang]?.feeDiscount1}
                    fontSize="18px"
                    color="#1A1D77"
                  >
                    {sectionContent?.[3]?.text}
                  </Box>
                </Flex>
                <Box
                  as="hr"
                  borderTop="1px solid rgb(155 120 0 / 50%)"
                  mt={4}
                />

                {priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StructuredTextParser
                      str={`${priceData[0].curr} ${
                        lang === 'id'
                          ? new Intl.NumberFormat('id').format(
                              priceData[0].coupon?.origPrice
                            )
                          : priceData[0].coupon?.origPrice
                      }`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#CD9F00"
                      fontSize={{ base: '30px', md: '36px' }}
                    />{' '}
                    <Box
                      fontSize={{ base: '26px', md: '32px' }}
                      color="#BD0015"
                      fontFamily="'FedraSansStd-A-medium'"
                      textAlign="center"
                      mt="10px"
                    >
                      {sectionContent?.[13]?.text}{' '}
                    </Box>
                    {showTimer && (
                      <StructuredTextParser
                        str={render(additionalText?.body)
                          ?.replace('#num#', priceData[0]?.coupon?.offerValue)
                          .replace(
                            '##COUPONCODE##',
                            priceData[0]?.coupon?.couponCode
                          )
                          .replace('##CURRENCY##', priceData[0]?.curr)
                          .replace(
                            '##PRICE##',
                            priceData[0]?.coupon?.offerValue
                          )}
                        color="#9B7800"
                        fontFamily="'FedraSansStd-medium'"
                        fontSize={{ base: '18px', md: '24px' }}
                        mt="5px"
                      />
                    )}
                    {showTimer && (
                      <DayTimeCounterText
                        currentDate={getLocalTime}
                        endDate={currentCoupon?.expiryDate}
                        sectionContent={sectionContent}
                        color="#1A1D77"
                      />
                    )}
                    <StructuredTextParser
                      str={`${priceData[0].curr} ${
                        lang === 'id'
                          ? new Intl.NumberFormat('id').format(
                              priceData[0]?.coupon?.postCouponPrice ||
                                priceData[0]?.discountedPrice
                            )
                          : priceData[0]?.coupon?.postCouponPrice ||
                            priceData[0]?.discountedPrice
                      }`}
                      maxW="none"
                      mt="0px"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#1A1D77"
                      fontFamily="'FedraSansStd-A-medium'"
                    />{' '}
                    {priceData.length > 1 && (
                      <>
                        <StructuredTextParser
                          str={render(sectionContent?.[6]?.body)}
                          maxW="none"
                          {...ProgramFeeSt[lang].regionalLanguages}
                          color="#A69786"
                        />

                        <StructuredTextParser
                          id="program-fee-price"
                          str={`${priceData[1].curr} ${priceData[1].pgmFee}`}
                          textDecoration="line-through"
                          maxW="auto"
                          mt="0px"
                          color="#6D6358"
                          {...ProgramFeeSt[lang].feeDiscount2}
                        />

                        <StructuredTextParser
                          str={`${priceData[1].curr} ${
                            lang === 'id'
                              ? new Intl.NumberFormat('id').format(
                                  priceData[1].discountedPrice
                                )
                              : priceData[1].discountedPrice
                          }`}
                          mt="0px"
                          maxW="auto"
                          color="#CD9F00"
                          {...ProgramFeeSt[lang].feeDiscount3}
                        />
                      </>
                    )}
                  </Flex>
                )}
              </Flex>
            ) : (
              <Flex
                bg="#fff !important"
                flexGrow="1"
                py={{ base: '20px', md: '30px' }}
                px={{ base: '20px', md: '70px' }}
                flexDir="column"
              >
                <Flex
                  alignItems={{ base: 'flex-start', md: 'center' }}
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  <Flex>
                    <svg
                      stroke="#be1931"
                      fill="#be1931"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="2.5em"
                      width="2.5em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                    </svg>
                  </Flex>
                  {/* <StructuredTextParser
                    id="program-fee-text"
                    mt="0"
                    str={render(sectionContent?.[3].body)}
                    {...ProgramFeeSt[lang].feeDiscount1}
                    maxW="auto"
                    color="#6D6358"
                  /> */}
                  <Box color="#6D6358" {...ProgramFeeSt[lang].feeDiscount1}>
                    {sectionContent?.[3]?.text}
                  </Box>
                </Flex>
                {/* Older Ui code */}
                {!changeUi && (
                  <Box
                    borderBottom={{
                      base: '1px solid #6D6358',
                      md: '2px solid #6D6358',
                    }}
                    opacity={0.3}
                    mt="20px"
                  />
                )}
                {!changeUi && priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StructuredTextParser
                      str={`${priceData[0].curr} ${
                        lang === 'id'
                          ? new Intl.NumberFormat('id').format(
                              priceData[0].pgmFee
                            )
                          : priceData[0].pgmFee
                      }`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#6D6358"
                    />{' '}
                    <StructuredTextParser
                      str={`${priceData[0].curr} ${
                        lang === 'id'
                          ? new Intl.NumberFormat('id').format(
                              priceData[0].discountedPrice
                            )
                          : priceData[0].discountedPrice
                      }`}
                      maxW="none"
                      mt="0px"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                    />{' '}
                    {priceData.length > 1 && (
                      <>
                        <StructuredTextParser
                          str={render(sectionContent?.[6]?.body)}
                          maxW="none"
                          {...ProgramFeeSt[lang].regionalLanguages}
                          color="#A69786"
                        />
                        <StructuredTextParser
                          id="program-fee-price"
                          str={`${priceData[1].curr} ${priceData[1].pgmFee}`}
                          textDecoration="line-through"
                          maxW="auto"
                          mt="0px"
                          color="#6D6358"
                          {...ProgramFeeSt[lang].feeDiscount2}
                        />

                        <StructuredTextParser
                          str={`${priceData[1].curr} ${
                            lang === 'id'
                              ? new Intl.NumberFormat('id').format(
                                  priceData[1].discountedPrice
                                )
                              : priceData[1].discountedPrice
                          }`}
                          mt="0px"
                          maxW="auto"
                          color="#CD9F00"
                          {...ProgramFeeSt[lang].feeDiscount3}
                        />
                      </>
                    )}
                    {(region === 'us' || region === 'ca') && (
                      <>
                        {searchByFieldId(
                          sectionContent,
                          'scholarships-link'
                        ) && (
                          <NextLink
                            href="#ieo-program-section"
                            passHref
                            legacyBehavior
                          >
                            <Link
                              onClick={() => {
                                scroll.scrollTo(
                                  scholarshipsRef?.current?.offsetTop,
                                  {
                                    duration: 500,
                                    smooth: true,
                                  }
                                );
                              }}
                              color="#CE6113"
                              fontFamily="'FedraSansStd-medium'"
                              textDecor="underline"
                              _hover={{ textDecor: 'none' }}
                            >
                              {
                                searchByFieldId(
                                  sectionContent,
                                  'scholarships-link'
                                ).buttonText
                              }
                            </Link>
                          </NextLink>
                        )}
                      </>
                    )}
                  </Flex>
                )}
                {region === 'us' || region === 'ca' ? (
                  <Box textAlign="center" pt="1.3rem" maxW="372px" mx="auto">
                    {searchByFieldId(sectionContent, 'retake-text') && (
                      <Text
                        as="span"
                        color="#CD9F00"
                        textAlign="center"
                        {...ProgramFeeSt[lang].alreadyCompleted}
                        pr="0"
                      >
                        {searchByFieldId(sectionContent, 'retake-text').text}{' '}
                      </Text>
                    )}
                    {searchByFieldId(sectionContent, 'click-here-link') && (
                      <Link
                        onClick={onOpen}
                        color="#CE6113"
                        fontFamily="'FedraSansStd-book'"
                        textDecor="underline"
                        _hover={{ textDecor: 'none' }}
                        whiteSpace="nowrap"
                      >
                        {
                          searchByFieldId(sectionContent, 'click-here-link')
                            .buttonText
                        }
                      </Link>
                    )}
                  </Box>
                ) : (
                  <Box textAlign="center" pt="1.3rem" maxW="372px" mx="auto">
                    {searchByFieldId(sectionContent, 'retake-info') && (
                      <Text
                        as="span"
                        color="#CD9F00"
                        textAlign="center"
                        {...ProgramFeeSt[lang].alreadyCompleted}
                        pr="5px"
                      >
                        {' '}
                        {searchByFieldId(sectionContent, 'retake-info').text}
                      </Text>
                    )}
                    {searchByFieldId(sectionContent, 'apply-link') && (
                      <Link
                        onClick={onOpen}
                        color="#CE6113"
                        fontFamily="'FedraSansStd-medium'"
                        textDecor="underline"
                        _hover={{ textDecor: 'none' }}
                      >
                        {
                          searchByFieldId(sectionContent, 'apply-link')
                            .buttonText
                        }
                      </Link>
                    )}
                  </Box>
                )}
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ProgramFeesEuDiscount;
